import React from 'react'

import { ReactComponent as RefreshIcon } from 'assets/svg/permission-denied/refresh.svg'
import { ReactComponent as MicrophoneIcon } from 'assets/svg/permission-denied/microphone.svg'
import './MicrophonePermissionDenied.scss'
import { useTranslation } from 'react-i18next'

export function MicrophonePermissionDenied() {
    const { t } = useTranslation()
    function onRestartHandler(e) {
        e.preventDefault()
        document.location.reload()
    }

    return (
        <div className="permission-denied-page">
            <h2 className="permission-denied-page__title">{t('mic_requirted')}</h2>
            <MicrophoneIcon />
            <div>
                <p className="permission-denied-page__text">{t('mic_requirted_desc')}</p>
                <button type="button" onClick={onRestartHandler} className="permission-denied-page__button">
                    <RefreshIcon />
                    {t('restart_app')}
                </button>
            </div>
        </div>
    )
}
